import { render, staticRenderFns } from "./scopecitycompany-add-or-update.vue?vue&type=template&id=1c1a2486&"
import script from "./scopecitycompany-add-or-update.vue?vue&type=script&lang=js&"
export * from "./scopecitycompany-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports